import { render } from "./AllFooter.vue?vue&type=template&id=713c8e5c&scoped=true"
import script from "./AllFooter.vue?vue&type=script&lang=js"
export * from "./AllFooter.vue?vue&type=script&lang=js"

import "./AllFooter.vue?vue&type=style&index=0&id=713c8e5c&lang=scss&scoped=true"

import exportComponent from "D:\\Spadej Work\\SPJWEB\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713c8e5c"]])

export default __exports__